import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useXeroCustomerSelection } from './hooks';

export const XeroCustomersDropdown: React.FC = () => {
  const { selectedCustomer, xeroCustomers, isFetching, handleInputChange, handleCustomerChange } =
    useXeroCustomerSelection();

  return (
    <Autocomplete
      options={xeroCustomers ?? []}
      getOptionLabel={(option) => option.name}
      value={selectedCustomer}
      onChange={handleCustomerChange}
      onInputChange={handleInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Xero ERP ID"
          placeholder="Select Xero Customer"
          slotProps={{
            ...params.slotProps,

            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isFetching && <CircularProgress color="inherit" size={20} />}
                  {params.slotProps.input.endAdornment}
                </>
              ),
            },

            inputLabel: {
              shrink: true,
            }
          }} />
      )}
    />
  );
};
